import { useStore } from "vuex";

export default function useRecentlyDeletedData() {
  const store = useStore();

  async function loadRecentlyDeletedData() {
    await store.dispatch("api/fetchRecentlyDeleted");
  }

  return {
    loadRecentlyDeletedData,
  };
}
